import { render, staticRenderFns } from "./assignment-list.component.vue?vue&type=template&id=31fb1175&scoped=true&"
import script from "./assignment-list.component.vue?vue&type=script&lang=ts&"
export * from "./assignment-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./assignment-list.component.vue?vue&type=style&index=0&id=31fb1175&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb1175",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
